import script from "./InputSelectMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSelectMultiple.vue?vue&type=script&setup=true&lang=js"

import "@/assets/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./InputSelectMultiple.vue?vue&type=style&index=1&id=6909e050&lang=scss"

const __exports__ = script;

export default __exports__